// ReturnsAds.jsx
import React, { useState } from "react";
import FourCards from "../../../components/FourCards";
import ComingSoonLink from "../../../components/ComingSoonLink";

const ReturnsAds = () => {
  const steps = [
    {
      title: "",
      description:
        "The data structure (file format) in which the e-TDS / e-TCS return is to be prepared has been notified below:",
      cards: [
        {
          // title: "Quarterly Returns",
          subTitle: "For regular statements pertaining for TY 2026-27 onwards:",
          firstColumn: [
            {
              text: "File Format for Form Number 138 Q1 to Q3 Version 1.2",
              href: "https://tinpan.proteantech.in/downloads/e-tds/Form Number 138-24Q - Q1 to Q3_22072026.xlsx",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form Number 138 Q4 Version 1.0 (Expected to be released soon)",
              href: "#",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form Number 140 Q1 to Q4 Version 1.2",
              href: "https://tinpan.proteantech.in/downloads/e-tds/Form Number 140 - 26Q - Q1 to Q4_22072026.xlsx",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "File Format for Form Number 144 Q1 to Q4 Version 1.2",
              href: "https://tinpan.proteantech.in/downloads/e-tds/Form Number 144-27Q - Q1 to Q4_22072026.xlsx",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form Number 143 Q1 to Q4 Version 1.2",
              href: "https://tinpan.proteantech.in/downloads/e-tds/Form Number 143-27EQ - Q1 to Q4_22072026.xlsx",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
        {
          title: "",
          subTitle: "For regular statements pertaining to FY 2010-11 onwards up to FY 2025-26:",
          firstColumn: [
            {
              text: "File Format for Form No. 24Q Q1 to Q3 Version 6.3",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q1_to_Q3_Version_6.3_27052025_201011.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 24Q (4th Quarter) Version 7.5 ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q4_Version_7.5_27052025_201112.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 26Q Q1 TO Q4 Version 7.8",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Regular_Q1_to_Q4_Version_7.8_27052025_201011.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "File Format for Form No. 27EQ Q1 to Q4 Version 6.9",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Regular_Q1_to_Q4_Version_6.9_ 27052025_201011.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 27Q Q1 to Q4 Version 7.5",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Regular_Q1_to_Q4_Version_7.5_27052025_201011.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
        {
          title: "For regular statements up to FY 2009-10:",
          subTitle: "",
          firstColumn: [
            {
              text: "File Format for Form No. 24Q Q1 to Q3 Version 5.8",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q1_to_Q3_Version_5.8_01062023_200910.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 24Q (4th Quarter) Version 6.2",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q4_Version_6.2_01062023_200910.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 26Q Q1 TO Q4 Version 5.8",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Regular_Q1_to_Q4_Version_5.8_01062023_200910.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "File Format for Form 27EQ Q1 to Q4 Version 5.8",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Regular_Q1_to_Q4_Version_5.8_%2001062023_200910.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "File Format for Form No. 27Q Q1 to Q4 Version 5.8",
              href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Regular_Q1_to_Q4_Version_5.8_01062023_200910.xls",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
        // {
        //   title: "",
        //   subTitle: "For Correction statements pertaining for FY 2026-27 onwards:",
        //   firstColumn: [
        //     {
        //       text: "File Format for Form Number 138 correction Q1 to Q3 Version 1.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q1_to_Q3_Version_5.8_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form Number 138 correction (4th Quarter) Version 1.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Regular_Q4_Version_6.2_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form Number 140 correction Q1 to Q4 Version 1.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Regular_Q1_to_Q4_Version_5.8_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        //   secondColumn: [
        //     {
        //       text: "File Format for Form Number 144 correction Q1 to Q4 Version 1.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Regular_Q1_to_Q4_Version_5.8_%2001062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form Number 143 correction Q1 to Q4 Version 1.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Regular_Q1_to_Q4_Version_5.8_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        // },
        // {
        //   title: "For correction statements up to FY 2009-10:",
        //   subTitle: "",
        //   firstColumn: [
        //     {
        //       text: "File Format for Form No. 24Q correction Q1 to Q3 Version 6.1",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q1_Q3_Version_6.1_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 24Q correction (4th Quarter) Version 6.3",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q4-Version_6.3_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 26Q correction Q1 to Q4 Version 6.1",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Correction_Q1_Q4_Version_6.1_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        //   secondColumn: [
        //     {
        //       text: "File Format for Form 27EQ correction Q1 to Q4 Version 6.1",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Correction_Q1_Q4_Version_6.1_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 27Q correction Q1 to Q4 Version 6.0",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Correction_Q1_Q4_Version_6.0_01062023_200910.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        // },
        // {
        //   title: "For correction statements pertaining to FY 2010-11 onwards:",
        //   subTitle: "",
        //   firstColumn: [
        //     {
        //       text: "File Format for Form No. 24Q correction Q1 to Q3 Version 7.3",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q1_to_Q3_Version_7.3_04022025_201012.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 24Q correction (4th Quarter) Version 7.6",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q4_Version_7.6_04022025_201011.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 26Q correction Q1 to Q4 Version 7.9",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Correction_Q1_to_Q4_Version_7.9_04022025_201011.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        //   secondColumn: [
        //     {
        //       text: "File Format for Form 27EQ correction Q1 to Q4 Version 7.4",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Correction_Q1_to_Q4_Version_7.4_04022025_201011.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //     {
        //       text: "File Format for Form No. 27Q correction Q1 to Q4 Version 7.7",
        //       href: "https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Correction_Q1_to_Q4_Version_7.7_04022025_201011.xls",
        //       style: { linkMaxWidth: "187px", textColor: "black" },
        //     },
        //   ],
        // },
      ],
    },
    {
      title: "",
      description:
        "e-TDS/e-TCS return in accordance with the file formats is to be prepared in clean text ASCII format with 'txt' as filename extension. e-TDS/e-TCS return can be prepared using in-house software, any other third party software or the Protean TDS Return Preparation Utility.",
      cards: [
        {
          title: "Quarterly Returns",
          subTitle: "For regular statements pertaining for FY 2026-27 onwards:",
          firstColumn: [
            {
              text: "Sample file for Form Number 138 (1st, 2nd & 3rd Quarter)",
              href: "https://tinpan.proteantech.in/downloads/e-tds/138RQ1.txt",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form Number 138 (4th Quarter) (expected to be released soon)",
              href: "#",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form Number 140 ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/140RQ1.txt",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "Sample file for Form Number 144",
              href: "https://tinpan.proteantech.in/downloads/e-tds/144RQ1.txt",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form Number 143",
              href: "https://tinpan.proteantech.in/downloads/e-tds/143.txt",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
        {
          title: "Quarterly Returns",
          subTitle: "For statement pertaining to FY 2010-11 up to 2025-26.",
          firstColumn: [
            {
              text: "Sample file for Form No. 24Q (1st, 2nd & 3rd Quarter) ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/24QQ3.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 24Q (4th Quarter) ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/24QQ4.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 26Q ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/26QQ1.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "Sample file for Form No. 27Q ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/27QQ2.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 27EQ ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/27EQRQ3.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
        {
          title: "For statement upto FY 2009-10",
          subTitle: "",
          firstColumn: [
            {
              text: "Sample file for Form No. 24Q (1st, 2nd & 3rd Quarter) ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/24QRQ1.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 24Q (4th Quarter) ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/24QRQ4.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 26Q ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/26QRQ1.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [
            {
              text: "Sample file for Form No. 27Q ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/27QRQ1.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "Sample file for Form No. 27EQ ",
              href: "https://tinpan.proteantech.in/downloads/e-tds/27EQRQ1.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
        },
      ],
    },
    {
      title: "",
      description:
        "Once the file has been prepared as per the file format, it should be verified using the File Validation Utility (FVU) provided by Protean e-Gov.:",
      cards: [
        {
          title: "",
          subTitle: "",
          firstColumn: [
            {
              text: "FVU version 1.2 - Applicable for e-TDS/TCS Statements pertaining to TY 2026-27 onwards (i.e. Forms Number 138, 140, 144 and 143) can be validated using this utility",
              href: "https://tinpan.proteantech.in/downloads/e-tds/download/TDS_STANDALONE_FVU_1.2.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "FVU version 9.5 – Applicable for e-TDS/TCS Statements pertaining to FY 2010-11 to 2025-26 (i.e. Forms 24Q, 26Q, 27Q and 27EQ) can be validated using this utility.",
              href: "https://tinpan.proteantech.in/downloads/e-tds/download/TDS_STANDALONE_FVU_9.5.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
            {
              text: "FVU version 2.191 – Applicable for e-TDS/TCS Statements pertaining up to 2009-10 (i.e. Forms 24Q, 26Q, 27Q and 27EQ) can be validated using this utility.",
              href: "https://tinpan.proteantech.in/downloads/e-tds/download/TDS_STANDALONE_FVU_2.191.zip",
              style: { linkMaxWidth: "187px", textColor: "black" },
            },
          ],
          secondColumn: [],
        },
      ],
    },
    {
      title: "",
      description:
        "In case file has any errors the FVU will give a report of the errors. Rectify the errors and verify the file again through the FVU. ",
      cards: [],
    },
    {
      title: "",
      description:
        "The upload file generated by the FVU on successful validation is to be furnished to a TIN-FC. Quarterly Return : Each e-TDS/TCS return saved in a CD/Pen Drive to be submitted along with a signed copy of the control chart (Form No. 27A). With effect from February 1, 2014, it is mandatory to submit Form No. 27A generated by TDS/TCS FVU (File Validation Utility) duly signed, along with the TDS/TCS statement(s). Any other Form No. 27A submitted will be treated as invalid submission and the same will be rejected by TIN-FC branches. (Form No. 27A).",
      cards: [],
    },
  ];

  const [activeStep, setActiveStep] = useState(0);

  return (
    <section className="px-4 lg:px-20 flex flex-col">
      {/* Tabs */}
      <div className="flex justify-around border-b border-gray-200 mb-8">
        {steps.map((step, index) => (
          <button
            key={index}
            onClick={() => { setActiveStep(index); console.log(activeStep) }}
            className={`py-2 px-4 font-semibold ${activeStep === index
              ? "text-[#54AD47] border-b-2 border-[#54AD47]"
              : "text-gray-500"
              }`}
          >
            Step {index + 1}
          </button>
        ))}
      </div>

      {/* Content */}
      <div>
        {steps[activeStep] && (
          <div className="flex flex-col gap-4">
            <h3 className="text-[18px] lg:text-[20px] font-semibold mb-4">
              {steps[activeStep].title}
            </h3>
            {steps[activeStep].description && (
              <p className="text-[14px] lg:text-[15px] mb-4">
                {steps[activeStep].description}
              </p>
            )}
            <div className="flex justify-center">
              <FourCards
                className="custom-class "
                data={steps[activeStep].cards}
                maxWidthDesktop="600px"
                minWidthDesktop="640px"
              />
            </div>
            <div>
              {steps[activeStep].description == "The data structure (file format) in which the e-TDS / e-TCS return is to be prepared has been notified below:" && (
                <div>
                  <table className="w-full text-center border-collapse">
                    <thead>
                      <tr>
                        <th className="w-1/2 border border-gray-300 px-4 py-3 bg-[#edf7ec]">For Correction statements pertaining for FY 2026-27 onwards:</th>
                        {/* <th className="w-1/2 border border-gray-300 px-4 py-3 bg-[#edf7ec]">
                        For Correction statements pertaining for FY 2026-27 onwards:{" "}
                        <span className="notice">(Expected to be released soon.)</span>
                      </th> */}
                        <th className="w-1/2 border border-gray-300 px-4 py-3 bg-[#edf7ec]">For Correction statements pertaining up to FY 2025-26:</th>
                      </tr>
                    </thead>
                    <tbody className="block w-full lg:table-row-group text-center">

                      <tr className="block  border border-gray-300 p-4 flex flex-col lg:table-row">
                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/download/Form Number 138-24Q - Q1 to Q3_04082026_correction.xlsx"
                            className="text-[#634B83]"
                          >
                            File Format for Form Number 138 correction Q1 to Q3 Version 1.2
                          </a>

                          {/* <ComingSoonLink>
                          File Format for Form Number 138 correction Q1 to Q3 Version 1.0
                        </ComingSoonLink> */}
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q1_to_Q3_Version_7.3_04022025_201012.xls"
                            className="text-[#634B83]"
                          >
                            File Format for Form No. 24Q correction Q1 to Q3 Version 7.3
                          </a>
                        </td>

                      </tr>

                      <tr className="block lg:table-row border border-gray-300 p-4 flex flex-col lg:table-row">

                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="#"
                            className="text-[#634B83]"
                          >
                            File Format for Form Number 138 correction (4th Quarter) Version 1.0
                          </a>
                        </td>

                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/File_Format_24Q_Correction_Q4_Version_7.6_04022025_201011.xls"
                            className="text-[#634B83]"
                          >
                            File Format for Form No. 24Q correction (4th Quarter) Version 7.6
                          </a>
                        </td>
                      </tr>
                      <tr className="block lg:table-row border border-gray-300 p-4 flex flex-col lg:table-row">
                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/download/Form Number 140-26Q - Q1 to Q4_04082026_correction.xlsx"
                            className="text-[#634B83]"
                          >
                            File Format for Form Number 140 correction Q1 to Q4 Version 1.2
                          </a>
                        </td>

                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/File_Format_26Q_Correction_Q1_to_Q4_Version_8.0_27052025_201011.xls"
                            className="text-[#634B83]"
                          >
                            File Format for Form No. 26Q correction Q1 to Q4 Version 8.0
                          </a>
                        </td>
                      </tr>
                      <tr className="block lg:table-row border border-gray-300 p-4">
                        <td className="border border-gray-300 px-4 py-3 align-middle" >
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/download/Form Number 144-27Q - Q1 to Q4_04082026_Correction.xlsx"
                            className="text-[#634B83]"
                          >
                            File Format for Form Number 144 correction Q1 to Q4 Version 1.2
                          </a>
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-middle" >
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/File_Format_27Q_Correction_Q1_to_Q4_Version_7.8_27052025_201011.xls"
                            className="text-[#634B83]"
                          >
                            File Format for Form No. 27Q correction Q1 to Q4 Version 7.8
                          </a>
                        </td>
                      </tr>
                      <tr className="block lg:table-row border border-gray-300 p-4">
                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/download/Form Number 143-27EQ - Q1 to Q4_04082026_correction.xlsx"
                            className="text-[#634B83]"
                          >
                            File Format for Form Number 143 correction Q1 to Q4 Version 1.2
                          </a>
                        </td>
                        <td className="border border-gray-300 px-4 py-3 align-middle">
                          <a
                            href="https://tinpan.proteantech.in/downloads/e-tds/File_Format_27EQ_Correction_Q1_to_Q4_Version_7.5_27052025_201011.xls"
                            className="text-[#634B83]"
                          >
                            File Format for Form No. 27EQ correction Q1 to Q4 Version 7.5
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>

          </div>
        )}
      </div>
    </section>
  );
};

export default ReturnsAds;